/*
 * ContractPage Constants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */


export const RESET_STATE = 'medarbeiderne-minside/ContractPage/RESET_STATE';

export const SET_VACATION = 'medarbeiderne-minside/ContractPage/SET_VACATION';

export const ORDER_BOX = 'medarbeiderne-minside/ContractPage/ORDER_BOX';

export const SKIP_PICKUP = 'medarbeiderne-minside/ContractPage/SKIP_PICKUP';
export const SKIP_PICKUP_SUCCESS = 'medarbeiderne-minside/ContractPage/SKIP_PICKUP_SUCCESS';
export const SKIP_PICKUP_FAILURE = 'medarbeiderne-minside/ContractPage/SKIP_PICKUP_FAILURE';

export const CHANGE_CONTRACT = 'medarbeiderne-minside/ContractPage/CHANGE_CONTRACT';
export const CHANGE_CONTRACT_SUCCESS = 'medarbeiderne-minside/ContractPage/CHANGE_CONTRACT_SUCCESS';
export const CHANGE_CONTRACT_FAILURE = 'medarbeiderne-minside/ContractPage/CHANGE_CONTRACT_FAILURE';
export const FETCH_CHANGE_PLANS = 'medarbeiderne-minside/ContractPage/FETCH_CHANGE_PLANS';
export const SET_CHANGE_PLANS = 'medarbeiderne-minside/ContractPage/SET_CHANGE_PLANS';

export const CHANGE_CARD = 'medarbeiderne-minside/ContractPage/CHANGE_CARD';
export const CHANGE_CARD_SUCCESS = 'medarbeiderne-minside/ContractPage/CHANGE_CARD_SUCCESS';
export const CHANGE_CARD_FAILURE = 'medarbeiderne-minside/ContractPage/CHANGE_CARD_FAILURE';

export const SUBSCRIPTION_STOP = 'medarbeiderne-minside/ContractPage/SUBSCRIPTION_STOP';
export const SUBSCRIPTION_STOP_SUCCESS = 'medarbeiderne-minside/ContractPage/SUBSCRIPTION_STOP_SUCCESS';
export const SUBSCRIPTION_STOP_FAILURE = 'medarbeiderne-minside/ContractPage/SUBSCRIPTION_STOP_FAILURE';

export const SUBSCRIPTION_REACTIVATE = 'medarbeiderne-minside/ContractPage/SUBSCRIPTION_REACTIVATE';
export const SUBSCRIPTION_REACTIVATE_SUCCESS = 'medarbeiderne-minside/ContractPage/SUBSCRIPTION_REACTIVATE_SUCCESS';
export const SUBSCRIPTION_REACTIVATE_FAILURE = 'medarbeiderne-minside/ContractPage/SUBSCRIPTION_REACTIVATE_FAILURE';

export const BECOME_SUBSCRIBER_FROM_INVOICE = 'medarbeiderne-minside/ContractPage/BECOME_SUBSCRIBER_FROM_INVOICE';
export const BECOME_SUBSCRIBER_FROM_INVOICE_SUCCESS = 'medarbeiderne-minside/ContractPage/BECOME_SUBSCRIBER_FROM_INVOICE_SUCCESS';
export const BECOME_SUBSCRIBER_FROM_INVOICE_FAILURE = 'medarbeiderne-minside/ContractPage/BECOME_SUBSCRIBER_FROM_INVOICE_FAILURE';

export const CHANGE_PAYMENT_METHOD = 'medarbeiderne-minside/ContractPage/CHANGE_PAYMENT_METHOD';
export const CHANGE_PAYMENT_METHOD_SUCCESS = 'medarbeiderne-minside/ContractPage/CHANGE_PAYMENT_METHOD_SUCCESS';
export const CHANGE_PAYMENT_METHOD_FAILURE = 'medarbeiderne-minside/ContractPage/CHANGE_PAYMENT_METHOD_FAILURE';


